import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {ShareMediaServicesPref} from '../constants';

/** are media services available */
export const mediaServicesAvailable = () =>
	getPublicProperty(ShareMediaServicesPref.ENABLED, true);
